import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ContactEndpoint, NewsletterEndpoint, Url } from "../../Type/BaseUrl";

const NewsletterService = createApi({
	reducerPath: "NewsletterService",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			newsletterContent: builder.mutation({
				query: (NewsData) => {
					return {
						url: NewsletterEndpoint,
						method: "Post",
						body: NewsData,
					};
				},
			}),
			contactContent: builder.mutation({
				query: (ContactData) => {
					return {
						url: ContactEndpoint,
						method: "Post",
						body: ContactData,
					};
				},
			}),
		};
	},
});

export const { useNewsletterContentMutation, useContactContentMutation } =
	NewsletterService;
export default NewsletterService;
